import { EAdminMercadoPagoQueryType } from "../../Enum/EAdminMercadoPagoQueryType"

export class AdminMercadoPagoQueryResult {
  queryType: EAdminMercadoPagoQueryType

  requestPath: string

  statusCode: number

  isSuccessStatusCode: boolean

  capturedAtUtc: string

  responseBody: string

  constructor(data: Partial<AdminMercadoPagoQueryResult> = {}) {
    this.queryType = data.queryType ?? EAdminMercadoPagoQueryType.Payment

    this.requestPath = data.requestPath ?? ""

    this.statusCode = data.statusCode ?? 0

    this.isSuccessStatusCode = data.isSuccessStatusCode ?? false

    this.capturedAtUtc = data.capturedAtUtc ?? ""

    this.responseBody = data.responseBody ?? ""
  }
}
